import PropTypes from "prop-types";
import { useEffect, useRef, useState } from "react";
import { Col, Form, Image, Row, Button, FloatingLabel, OverlayTrigger, Tooltip } from "react-bootstrap";
import { calculator } from "../utils/Calculator";
import {
  AddImageIcon,
  DeleteIcon,
  ImageFileIcon,
  SortedArrowIcon,
  ViewImageIcon
} from "../data/iconImage";
import { filteredItemInArray, hasDuplicateValues } from "../utils/ManageArray";
import {
  autoDisplayValue,
  formatSplitKey,
  plusStringValue
} from "../commons/FormatValue";
import {
  FloatingControlComponent,
  FormCheckComponent,
  FormControlComponent,
  SearchSelectComponent
} from "./FormComponent";
import BarcodeGenerator from "./BarcodeGenerator";
import TableLimitPagination from "./TableLimitPagination";
import ButtonOptionSubmenu from "./ButtonOptionSubmenu";
import { useAlert } from "../context/AlertContext";
import { useNavigate } from "react-router-dom";
import LoadingSpinner from "./LoadingSpinner";

// scrollbar & sortByAPI
const TableForm2s = ({
  data,
  columns,
  duplicateKey,
  checkBoxShow = false,
  onChangeCallback,
  rowsPerPage,
  currentPage,
  rowCount,
  fetchData,
  pagination = true,
  minHeight,
  sorting,
  previewButton,
  editButton,
  deleteButton,
  showDeleteButton,
  callbackImage,
  isLoading,
  validated,
  hideMoreButton,
  onDeleteCallback,
  allData,
  isEditIndex
}) => {
  const [newData, setNewData] = useState([]);
  const [sortBy, setSortBy] = useState("rowIndex");
  const [sortOrder, setSortOrder] = useState("asc");
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [displayValue, setDisplayValue] = useState({
    findValue: null,
    options: null
  });
  const [showModal, setShowModal] = useState(false);

  const handleSort = (name) => {
    const nextOrder =
      sortBy === name ? (sortOrder === "asc" ? "desc" : "asc") : "asc";
    if (sorting) {
      if (!allData) {
        fetchData({ sort: name, order: nextOrder });
      } else {
        const allNewSort = allData.sort((a, b) => {
          if (nextOrder == "asc") return a[name]?.localeCompare(b[name])
          if (nextOrder == "desc") return b[name]?.localeCompare(a[name])
        })
        onChangeCallback(allNewSort, true)
      }
      setSortBy(name);
      setSortOrder(nextOrder);
    }
  };

  const handleDisplay = (name, value, options) => {
    columns.forEach(({ findValue }) => {
      if (findValue?.value === name) {
        const { data, key } = findValue || {};
        const filteredFind = filteredItemInArray(data, key, value);
        const filteredOption = filteredItemInArray(options, "value", value);
        setDisplayValue((prev) => ({
          ...prev,
          findValue: {
            ...prev.findValue,
            [name]: prev.findValue?.[name]
              ? [...prev.findValue?.[name], ...filteredFind]
              : filteredFind
          },
          options: {
            ...prev.options,
            [name]: prev.options?.[name]
              ? [...prev.options?.[name], ...filteredOption]
              : filteredOption
          }
        }));
      }
    });
  };

  const handleChange = (index, name, value, options) => {
    const updatedData = [
      ...newData?.slice(0, index),
      { ...newData[index], [name]: value, isEdit: isEditIndex ? index : true },
      ...newData?.slice(index + 1)
    ];

    handleDisplay(name, value, options);

    setNewData(updatedData);
    // if (component === "planningForm") {
    if (allData) {
      const ind = index + rowsPerPage * (currentPage - 1)
      let oldValue = [...allData];
      oldValue[ind][name] = value;
      let newValue = oldValue;
      onChangeCallback(newValue, displayValue);
    } else {
      onChangeCallback(updatedData, displayValue);
    }
  };

  const calculateValues = ({ row, sumValue }) => {
    const { firstName, secondName, operator } = sumValue;
    const num1 = Number(row?.[firstName]);
    const num2 = Number(row?.[secondName]);

    return calculator({ num1, num2, operator });
  };

  const handleCheckboxChange = (index, name, value) => {
    const updatedCheckboxState = [...newData];
    updatedCheckboxState[index] = {
      ...updatedCheckboxState[index],
      isChecked: value
    };

    const allChecked = updatedCheckboxState.every(({ isChecked }) => isChecked);
    const someChecked = updatedCheckboxState.some(({ isChecked }) => isChecked);

    setNewData(updatedCheckboxState);
    let prevAll = [...allData];
    const ind = index + rowsPerPage * (currentPage - 1)
    prevAll[ind][name] = value;
    let newAll = prevAll;
    handleDisplay(name, value);

    if (allData) {
      onChangeCallback(newAll);
    } else {
      onChangeCallback(updatedCheckboxState);
    }
    setSelectAllChecked(allChecked ? true : someChecked ? null : false);
  };

  const handleSelectAllChange = () => {
    if (!allData) {
      const updatedCheckboxState = newData.map((row) => ({
        ...row,
        isChecked: !selectAllChecked
      }));

      setNewData(updatedCheckboxState);
      onChangeCallback(updatedCheckboxState);
    } else {
      const allNewCheck = allData.map((row) => {
        return {
          ...row,
          isChecked: !selectAllChecked
        }
      });
      onChangeCallback(allNewCheck, true)
    }

    setSelectAllChecked(!selectAllChecked);
  };

  useEffect(() => {
    setNewData(data || []);
    // if(isLoading && data?.length) setisLoading(false)
  }, [data, newData]);


  return (
    <>
      {/* minHeight '300px' for dropdownSelector */}
      <div className="table-responsive" style={{ overflowX: "scroll", paddingTop: "10px", minHeight: newData?.length && minHeight }}>
        <Form.Group className="TableForm ">
          <table className="table table-hover mb-0">
            <thead className="fs-3">
              <tr>
                {checkBoxShow && (
                  <th scope="col" style={{ width: "50px" }}>
                    {/* className="d-flex justify-content-center align-items-center" */}
                    <FormCheckComponent
                      type="checkbox"
                      className={{ input: "ms-3 mb-2" }}
                      onChange={handleSelectAllChange}
                      checked={selectAllChecked}
                    />
                  </th>
                )}
                <th scope="col" style={{ width: "75px" }}>
                  <Form.Label
                    className={`d-flex fs-3 fw-bold ${!sorting && "justify-content-center"
                      }`}
                    onClick={() => !allData && handleSort("rowIndex", 0)}
                  >
                    ลำดับ
                    {sorting && sortBy === "rowIndex" &&
                      !allData && (
                        <Image
                          src={SortedArrowIcon}
                          alt="Sorted Icon"
                          style={{
                            rotate: sortOrder === "asc" ? "180deg" : "0deg"
                          }}
                        />
                      )}
                  </Form.Label>
                </th>
                {columns.map(
                  ({ name, label, size, width, format, type, center }, idx) => (
                    <th key={name} scope="col">
                      <Form.Label
                        style={{
                          minWidth:
                            width ||
                            (type == "activeButton" && "195px") ||
                            ((format || type == "date" || type == "select") &&
                              "167px") ||
                            ((type == "addImage" || type == "viewImage") &&
                              "100px") ||
                            "150px"
                        }}
                        className={`${center && "justify-content-center "
                          } d-flex fs-3 fw-bold ${(type == "addImage" || type == "viewImage") &&
                          "justify-content-center"
                          }`}
                        onClick={() => handleSort(name, idx)}
                      >
                        {label}
                        {sorting && sortBy === name && (
                          <Image
                            src={SortedArrowIcon}
                            alt="Sorted Icon"
                            style={{
                              rotate: sortOrder === "asc" ? "180deg" : "0deg"
                            }}
                          />
                        )}
                      </Form.Label>
                    </th>
                  )
                )}
              </tr>
            </thead>

            {isLoading ? (
              <tbody className="border-bottom">
                <td colSpan="100%" className="p-0">
                  <center className="p-0">
                    {" "}
                    <LoadingSpinner />{" "}
                  </center>
                </td>
              </tbody>
            ) : newData.length > 0 ? (
              <tbody className="fs-4">
                {newData?.map((row, index) => (
                  <tr key={row.Id}>
                    {checkBoxShow && (
                      <td style={{ width: "50px" }}>
                        <FormCheckComponent
                          type="checkbox"
                          name="isChecked"
                          className={{ input: "ms-3 mt-2" }}
                          onChange={() =>
                            handleCheckboxChange(
                              index,
                              "isChecked",
                              !row?.isChecked
                            )
                          }
                          checked={row?.isChecked || false}
                        />
                      </td>
                    )}
                    <td className="py-0">
                      <InputComponent
                        readOnly
                        type="text"
                        className={{
                          input:
                            "border-0 px-1 text-center shadow-none bg-transparent"
                        }}
                        value={
                          pagination
                            ? index + 1 + rowsPerPage * (currentPage - 1)
                            : index + 1
                        }
                      />
                    </td>
                    {columns.map(
                      (
                        {
                          name,
                          label,
                          type,
                          size,
                          min,
                          max,
                          options,
                          format,
                          filterBy,
                          sumValue,
                          findValue,
                          plusString,
                          readOnly,
                          disabled,
                          pattern,
                          feedbackMessage,
                          noneRequired,
                          required,
                          minKeywordLength,
                          queryService,
                          noneAsync,
                          inputClass,
                          showTooltip,
                          onClick,
                          center,
                          selectorColor,
                          defaultOption
                        },
                        idx
                      ) => {
                        const colVal = formatSplitKey(name, ".", row);
                        const arrFindVal =
                          displayValue?.findValue?.[findValue?.value || name];
                        const arrOptions =
                          displayValue?.options?.[findValue?.value || name];
                        const findRowVal = row?.[findValue?.value];
                        const filterVal = filteredItemInArray(
                          arrFindVal,
                          findValue?.key,
                          findRowVal
                        );
                        const filterOp = filteredItemInArray(
                          arrOptions,
                          "value",
                          colVal
                        );
                        const option =
                          filterOp?.length > 0 ? filterOp : options;
                        const findedVal = autoDisplayValue({
                          name,
                          type,
                          findValue: {
                            ...findValue,
                            data: filterVal,
                            value: findRowVal
                          }
                        });
                        const result =
                          (format ? format(row) : "") ||
                          (sumValue && calculateValues({ row, sumValue })) ||
                          (plusString &&
                            plusStringValue(plusString, "  ", row)) ||
                          (findValue && findedVal) ||
                          (colVal === false
                            ? false
                            : colVal === 0
                              ? "0"
                              : colVal);
                        const validDupilcate =
                          duplicateKey?.some((dup) => dup === name) &&
                          hasDuplicateValues(newData, duplicateKey);

                        let defaultOpt = [{ value: row[name], label: row[defaultOption?.label]?.label }]
                        return (
                          <td key={name + idx} className="py-0">
                            {type === "select" ? (
                              <div className={`table-form2 ${!minHeight && newData.length < 6 && 'fixed-dropdown'} 
                              ${selectorColor ? (result == "true" ? "selector-text-red" : "selector-text-blue") : ""}
                               ${validated && required && (row?.isChecked || false) && !result && "selector-text-red"}`}>
                                <SearchSelectComponent
                                  labelField={name}
                                  filterBy={filterBy}
                                  disabled={disabled}
                                  noneAsync={noneAsync}
                                  placeholder="โปรดเลือก"
                                  minKeywordLength={minKeywordLength}
                                  options={((defaultOption?.label && result) ? defaultOpt : option)}
                                  queryService={queryService}
                                  isInvalid={
                                    (!noneRequired &&
                                      ["", null].includes(result)) ||
                                    result === false ||
                                    validDupilcate
                                  }
                                  onChange={(change) =>
                                    handleChange(
                                      index,
                                      name,
                                      change?.value,
                                      option
                                    )
                                  }
                                  value={result}
                                  hideTooltip={!showTooltip}
                                // showTooltip={data[idx]?.isEdit} 
                                />
                              </div>
                            ) : type === "barcode" ? (
                              result && <BarcodeGenerator value={`${result}`} />
                            ) : type === "activeButton" ? (
                              <div
                                style={{ display: "grid", textAlign: "right" }}
                                className="pt-2"
                              >
                                <ButtonOptionSubmenu
                                  data={row}
                                  state={{ preview: row, edit: row }}
                                  previewButton={previewButton}
                                  editButton={editButton}
                                  deleteButton={deleteButton}
                                  onDeleteCallback={onDeleteCallback}
                                  showDeleteButton={showDeleteButton}
                                  hideMoreButton={hideMoreButton}
                                />
                              </div>
                            ) : type === "image" ? (
                              <img src={result} width={size || "180px"} className="m-1 mr-4" />
                            ) : type === "addImage" ? (
                              <center>
                                <AddPhoto
                                  data={data}
                                  index={index}
                                  accept="image/png, image/jpeg, image/jpg"
                                  handleChange={handleChange}
                                  name={name}
                                  disabled={disabled}
                                />
                              </center>
                            ) : type === "viewImage" ? (
                              <center>
                                {!!row[columns[idx - 1]?.name]?.length && (
                                  <Button
                                    variant="outline-light"
                                    className="p-2 ps-3 my-1 d-flex justify-content-center align-items-center rounded-circle"
                                    onClick={() => callbackImage(row[columns[idx - 1]?.name])}
                                  >
                                    <Image
                                      className="me-2"
                                      src={ViewImageIcon}
                                      alt="Add Image Icon"
                                    />
                                  </Button>
                                )}
                              </center>
                            ) : (
                              <div
                                id="input-form2"
                                onClick={() => onClick && onClick(row)}
                              >
                                <InputComponent
                                  type={type}
                                  name={name}
                                  label={label}
                                  pattern={pattern}
                                  readOnly={readOnly}
                                  disabled={disabled}
                                  min={row?.[min] || `${min}`}
                                  max={row?.[max] || `${max}`}
                                  placeholder="โปรดระบุ"
                                  className={{
                                    input: `border-0 ${inputClass} px-1 text-truncate ${onClick
                                      ? "cursor-pointer"
                                      : "cursor-default"
                                      }
                                  ${(readOnly || disabled) && "bg-transparent"}
                                `
                                  }}
                                  feedbackMessage={feedbackMessage}
                                  required={
                                    (!noneRequired && result === "") ||
                                    validDupilcate
                                  }
                                  onChange={({ target }) =>
                                    handleChange(
                                      index,
                                      name,
                                      target?.value.toUpperCase()
                                    )
                                  }
                                  value={result}
                                  center={center}
                                  showTooltip={showTooltip}
                                />
                              </div>
                            )}
                          </td>
                        );
                      }
                    )}
                  </tr>
                ))}
              </tbody>
            ) : (
              <tbody className="border-bottom">
                <td
                  colSpan="100%"
                  className="py-2 fs-4 text-center text-secondary w-100"
                >
                  <div> ไม่พบข้อมูล</div>
                </td>
              </tbody>
            )}
          </table>
        </Form.Group>
      </div>
      {pagination && (
        <TableLimitPagination
          data={data}
          paginationProps={{
            rowsPerPage: rowsPerPage,
            currentPage: currentPage,
            rowCount: rowCount,
            onChangeRowsPerPage: (num) => fetchData({ limit: num, page: 1 }),
            onChangePage: (page) => fetchData({ page: page })
          }}
        />
      )}
    </>
  );
};

TableForm2s.propTypes = {
  data: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  isLoading: PropTypes.bool,
  duplicateKey: PropTypes.array,
  checkBoxShow: PropTypes.bool,
  onChangeCallback: PropTypes.func,
  rowsPerPage: PropTypes.number,
  currentPage: PropTypes.number,
  rowCount: PropTypes.number,
  fetchData: PropTypes.func,
  pagination: PropTypes.bool,
  minHeight: PropTypes.string,
  sorting: PropTypes.bool,
  previewButton: PropTypes.object,
  editButton: PropTypes.object,
  deleteButton: PropTypes.func,
  callbackImage: PropTypes.func,
  component: PropTypes.string,
  showDeleteButton: PropTypes.bool,
  hideMoreButton: PropTypes.bool,
  onDeleteCallback: PropTypes.func,
  allData: PropTypes.array,
  validated: PropTypes.bool,
  isEditIndex: PropTypes.string,
};

const AddPhoto = ({ accept, index, data, handleChange, name, disabled }) => {
  const fileInputMedia = useRef(null);
  const { showAlert } = useAlert();

  const handleFileChange = async (e) => {
    const files = Array.from(e.target.files);
    e.target.value = null;

    if (files.find(({ size }) => size > 1024 * 1024 * 25)) {
      return showAlert({
        error: "คำเตือน",
        message: "ขนาดไฟล์ใหญ่เกินไป กรุณาเลือกไฟล์ที่มีขนาดไม่เกิน 25 MB",
        type: "warning"
      });
    }

    handleChange(index, name, [...data[index][name], files[0]])
    // const clone = [...data];
    // const row = clone[index];
    // const dataFile = files[0];
    // row.file = [...row.file, dataFile];
    // onChangeCallback(clone);

    // UploadFile(dataFile, row.Id)
  };

  return (
    <>
      <Button
        variant="outline-light"
        className="p-2 ps-3 my-1 d-flex justify-content-center align-items-center rounded-circle"
        onClick={() => fileInputMedia.current.click()}
        disabled={disabled}
      >
        <Image className="me-2" src={AddImageIcon} alt="Add Image Icon" />
      </Button>

      <Form.Control
        // multiple
        type="file"
        accept={accept}
        className="d-none"
        ref={fileInputMedia}
        onChange={handleFileChange}
      />
    </>
  );
};
AddPhoto.propTypes = {
  name: PropTypes.string,
  accept: PropTypes.string,
  index: PropTypes.number,
  data: PropTypes.array,
  handleChange: PropTypes.func,
  disabled: PropTypes.bool
};

export default TableForm2s;

const InputComponent = ({
  min,
  max,
  type,
  name,
  label,
  pattern,
  required,
  readOnly,
  disabled,
  className,
  placeholder,
  feedbackMessage,
  placement = "bottom-start",
  onChange,
  value,
  style,
  center,
  showTooltip = false
}) => {
  const tooltip = (showTooltip && value) ? (
    <Tooltip id={`tooltip-${name}`}>
      {type === "date" ? formatDate(value) : value}
    </Tooltip>
  ) : (
    <></>
  );

  return (
    <OverlayTrigger placement={placement} overlay={tooltip}>
      <FloatingLabel
        label={label}
        controlId={name}
        className={`fs-5 ${className?.label || ""}`}
        style={style?.label}
      >
        <Form.Control
          min={min || null}
          max={max || null}
          type={type || null}
          name={name || null}
          pattern={pattern || null}
          required={required || null}
          readOnly={readOnly || null}
          disabled={disabled || null}
          placeholder={placeholder || null}
          className={`p-3 fs-4 ${className?.input || ""} ${center ? 'text-center' : ''}  `}
          onChange={onChange || null}
          style={style?.input || null}
          value={value || ""}
        />
        {pattern && (
          <Form.Control.Feedback tooltip type="invalid" className="text-start">
            {feedbackMessage}
          </Form.Control.Feedback>
        )}
      </FloatingLabel>
    </OverlayTrigger>
  );
};

InputComponent.propTypes = {
  type: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  pattern: PropTypes.string,
  required: PropTypes.bool,
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.object,
  placement: PropTypes.string,
  placeholder: PropTypes.string,
  feedbackMessage: PropTypes.string,
  onChange: PropTypes.func,
  style: PropTypes.object,
  min: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  max: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  center: PropTypes?.bool,
  showTooltip: PropTypes.bool,
};